export const getTagDSTheme = (rcTheme?: string, _container?: string) => {
  if (rcTheme?.includes("lhh")) return "lhh-2025";
  if (rcTheme?.includes("pontoon")) return "pontoon";
  switch (rcTheme) {
    case "adecco-theme":
      return "adecco";
    case "akkodis-theme":
      return "akkodis";
    case "adecco-group-theme":
    default:
      return rcTheme;
  }
};
